import aboutimg from "./images/about-us.png";
import resume from "./resume/Girish-Resume-Front-end.pdf"

export default function About() {
  return (
    <>
      <div className="flex w-full h-auto lg:min-h-screen justify-center items-center">
        <div className="aboutContainer flex w-4/5">
          <div className="left-container hidden lg:block w-2/5">
            <img src={aboutimg} alt="aboutimage" />
          </div>
          <div className="right-container w-full lg:w-3/5 flex justify-center mb-5">
            <div className="w-full lg:w-2/3 ml-0 lg:ml-20">
              <h1 className="text-4xl font-bold leading-normal mb-5">
                LET’S <br /> INTRODUCE ABOUT <br />
                MYSELF
              </h1>
              <p className="mb-5 text-sm">
                Hi! I'm Girish, I love building cool stuff with code.I'm all
                about using technology to make life easier and more enjoyable.
              </p>
              <p className="mb-5 text-sm">
                I spend my days coding and designing websites that are not only
                functional but also look great and are easy to use. Take a look
                around and see what I've been working on. If you want to chat
                about web development or have a project in mind, feel free to
                get in touch. Let's make something awesome together!
              </p>
              <button className="rounded-lg px-10 py-3 bg-violet-600 text-white font-bold border-2 border-violet-600 hover:bg-white hover:text-black transition-all duration-300 shadow-lg shadow-violet-400 hover:shadow-none mt-5">
              <a href={resume} download="Girish_Resume_Front_end.pdf" >
                Download CV
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
        <div id="portfolio" className="mb-16"></div>
    </>
  );
}
